// ============================================================================
// Data Access Layer Exports
// ============================================================================

// Bookings
export {
  getBookingsForDate,
  getBookingsForDateRange,
  getBooking,
  getUpcomingBookings,
  isTimeSlotAvailable,
  computeDisabledSlots,
  getValidTimeSlots,
  createBooking,
  cancelBooking,
  rescheduleBooking,
  sendBookingReminder,
  confirmBooking,
  markBookingPaid,
  requestBookingConfirmation,
  type CreateBookingData,
} from './bookings';

// Customers
export {
  getCustomers,
  searchCustomers,
  getCustomer,
  getCustomersWithActivity,
  getCustomersByStaff,
  createCustomer,
  updateCustomer,
  type CreateCustomerData,
} from './customers';

// Payments
export {
  getPaymentsForToday,
  getPaymentsForDateRange,
  getRecentPayments,
  getPaymentStats,
  getTodayEarnings,
  createPayment,
  deletePayment,
  type CreatePaymentData,
} from './payments';

// Services
export {
  getServices,
  getAllServices,
  getService,
  getServiceEffectivePrice,
} from './services';

// Staff
export {
  getStaffMembers,
  getAllStaffMembers,
  getStaffMember,
  getCurrentUserStaffMember,
} from './staff';

// Alerts
export {
  getOpenAlerts,
  getAlertCount,
  resolveAlert,
} from './alerts';

// Inbox
export {
  getInboxMessages,
  getUnreadMessageCount,
  markMessageAsRead,
  markAllMessagesAsRead,
  // Notifications
  getNotifications,
  getUnreadNotificationCount,
  markNotificationRead,
  markAllNotificationsRead,
} from './inbox';

// Automations
export {
  getAutomationRules,
  toggleAutomationRule,
  createDefaultAutomationRules,
  updateAutomationConfig,
} from './automations';

// Business
export {
  getBusiness,
  getBusinessHours,
  getPreferences,
  createBusiness,
  updateBusiness,
  updateBusinessHours,
  updatePreferences,
  updateServices,
  updateStaffRole,
  updateProfile,
  type CreateBusinessData,
} from './business';

// NOTE: sales-cache.ts is server-only and should be imported directly:
// import { getSalesSummary } from '@/lib/features/data/sales-cache';

